const FollowCardSkeleton = () => {
  return (
    <div>
      <div className="w-[193px] h-[193px] bg-[#1a1919] animate-pulse mt-2"></div>
    </div>
  );
};

export default FollowCardSkeleton;
